module.exports = __webpack_public_path__ + "static/media/hbms.ecb47998.jfif";